import React from 'react';
import Style from './style.sass';

const textField = ({label, className, value, onChange}) => {
  return (
    <div className={className}>
      <label>{label}</label>
      <input type='text' value={value} onChange={onChange}/>
    </div>
  )
}
export default textField;